module.exports = __webpack_public_path__ + "static/media/loginPageBackground.60b086e8.webp";